import { Controller } from '@hotwired/stimulus'

// Fetches HTML preview fragments with multiple query params (archive dates or cleaned dates + event checkboxes).
//
// data-controller="recovery-fetch"
// data-recovery-fetch-url-value="/path/to/preview"
// data-recovery-fetch-mode-value="archive" | "cleaned"
// data-recovery-fetch-target="output"
// For mode=archive: targets archiveStarts, archiveEnds, optional action on inputs
// For mode=cleaned: targets cleanedStarts, cleanedEnds, eventCheckbox (multiple)

export default class extends Controller {
  static targets = ['output', 'archiveStarts', 'archiveEnds', 'cleanedStarts', 'cleanedEnds', 'eventCheckbox']
  static values = {
    url: String,
    mode: String,
    debounce: { type: Number, default: 300 }
  }

  connect() {
    this._timer = null
    this.scheduleFetch()
  }

  disconnect() {
    clearTimeout(this._timer)
  }

  scheduleFetch() {
    clearTimeout(this._timer)
    this._timer = setTimeout(() => this.fetchNow(), this.debounceValue)
  }

  fetchNow() {
    const url = new URL(this.urlValue, window.location.origin)

    if (this.modeValue === 'archive') {
      if (this.hasArchiveStartsTarget) {
        url.searchParams.set('recover_archived_starts_at', this.archiveStartsTarget.value || '')
      }
      if (this.hasArchiveEndsTarget) {
        url.searchParams.set('recover_archived_ends_at', this.archiveEndsTarget.value || '')
      }
    } else if (this.modeValue === 'cleaned' || this.modeValue === 'cleaned_all') {
      if (this.hasCleanedStartsTarget) {
        url.searchParams.set('cleaned_starts_at', this.cleanedStartsTarget.value || '')
      }
      if (this.hasCleanedEndsTarget) {
        url.searchParams.set('cleaned_ends_at', this.cleanedEndsTarget.value || '')
      }
      if (this.modeValue === 'cleaned' && this.hasEventCheckboxTarget) {
        this.eventCheckboxTargets
          .filter((el) => el.checked)
          .forEach((el) => {
            const v = el.value
            if (v) url.searchParams.append('cleaned_event_types[]', v)
          })
      }
    }

    window
      .fetch(url.toString(), {
        headers: { Accept: 'text/html', 'X-Requested-With': 'XMLHttpRequest' },
        credentials: 'same-origin'
      })
      .then((r) => (r.ok ? r.text() : null))
      .then((html) => {
        if (html !== null && this.hasOutputTarget) this.outputTarget.innerHTML = html
      })
      .catch(() => {
        if (this.hasOutputTarget) {
          this.outputTarget.innerHTML = '<p class="text-danger small mb-0">Could not load preview. Try again.</p>'
        }
      })
  }
}
